import { PhoneNumberSettingForm } from "../../organisms/form/PhoneNumberSettingForm";
import { CardTemplate } from "../../templates/CardTemplate";
import { usePhoneNumberSetting } from "./hook";

export const PhoneNumberSettingPage: React.FC = () => {
  const { handlePhoneNumberSetting } = usePhoneNumberSetting();

  return (
    <CardTemplate title="電話番号設定">
      <PhoneNumberSettingForm handleSubmit={handlePhoneNumberSetting} />
    </CardTemplate>
  );
};
